import {useMappedState} from 'redux-react-hook'
import {DECIMAL_PLACE, QTY_DECIMAL_PLACE} from 'constants'
import useRouter from 'hooks/useRouter'

function useSymbolInfo () {
  const router = useRouter()
  const {lng = 'en'} = router.query

  const mapState = state => {
    const symbolInfo = state?.entities?.symbolInfo || {}
    const exchangeInfos = state?.entities?.exchangeInfos || {}
    return {
      symbolInfo: {
        ...symbolInfo,
        maxLen: 10,
        lng,
        ...(exchangeInfos[symbolInfo.symbol] || {
          quoteAsset: 'USDT',
          pricePrecision: DECIMAL_PLACE,
          quantityPrecision: QTY_DECIMAL_PLACE
        })
      }
    }
  }
  return useMappedState(mapState)
}

export default useSymbolInfo
